import { showError } from '@components/toaster';

export const fetchAndDownload = async (url: string, fileName: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      showError('Failed to download file');
      return;
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    showError('Failed to download file');
  }
};
